import React, {
  useEffect,
  useMemo,
} from 'react';
import {
  Form,
  Divider,
  Select,
} from 'antd';
import PropTypes from 'prop-types';

import GanttScheduleColumnsSection from '../GanttScheduleColumnsSection';
import {
  DEFAULT_WEEK_HEADER_DISPLAY,
  getGanttColumns,
  WEEK_HEADER_DISPLAY_OPTIONS,
} from '../ganttScheduleHelpers';

export default function GanttScheduleAppearanceSettingsTab(props) {
  const {
    userSettings,
    visibleColumns,
    setVisibleColumns,
    weekHeaderDisplay,
    setWeekHeaderDisplay,
    visible,
    isMaster,
  } = props;

  const ganttColumns = useMemo(() => getGanttColumns(isMaster), [isMaster]);

  useEffect(() => {
    if (visible) {
      if (userSettings.ganttScheduleSettings) {
        try {
          const parsedSettings = JSON.parse(userSettings.ganttScheduleSettings);
          setVisibleColumns(parsedSettings.visibleColumns);
          setWeekHeaderDisplay(parsedSettings.weekHeaderDisplay || DEFAULT_WEEK_HEADER_DISPLAY);
        } catch (e) {
          setVisibleColumns([ganttColumns[0]]);
          setWeekHeaderDisplay(DEFAULT_WEEK_HEADER_DISPLAY);
        }
      } else {
        setVisibleColumns([ganttColumns[0]]);
        setWeekHeaderDisplay(DEFAULT_WEEK_HEADER_DISPLAY);
      }
    }
  }, [userSettings, visible, ganttColumns, setVisibleColumns, setWeekHeaderDisplay]);

  return (
    <Form
      style={{
        maxWidth: '95%',
      }}
      layout="vertical"
    >
      <h2>User Preferences</h2>
      <Divider style={{ margin: '10px 0px' }} />
      <h3>Week View Header</h3>
      <p>Choose what to display in the gantt schedule header when using week view.</p>
      <Form.Item>
        <Select
          value={weekHeaderDisplay}
          onChange={setWeekHeaderDisplay}
          options={WEEK_HEADER_DISPLAY_OPTIONS}
          style={{ maxWidth: 300 }}
        />
      </Form.Item>
      <Divider style={{ margin: '10px 0px' }} />
      <GanttScheduleColumnsSection
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
    </Form>
  );
}

GanttScheduleAppearanceSettingsTab.propTypes = {
  userSettings: PropTypes.shape({
    ganttScheduleSettings: PropTypes.string,
  }),
  visibleColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  setVisibleColumns: PropTypes.func.isRequired,
  weekHeaderDisplay: PropTypes.string.isRequired,
  setWeekHeaderDisplay: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  isMaster: PropTypes.bool.isRequired,
};

GanttScheduleAppearanceSettingsTab.defaultProps = {
  userSettings: {
    ganttScheduleSettings: '',
  },
};
